import { useEffect, useState } from "react";
import { fetchNews } from "../../api/wp";
import {
  EXCLUDED_POST_TITLES,
  FALLBACK_POSTS,
  POST_THUMB_OVERRIDES,
  PRESS_RELEASES,
} from "../data/news";

const strip = (html = "") =>
  html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&#8230;|\[&hellip;\]|&hellip;/g, "…")
    .replace(/&amp;/g, "&")
    .trim();

function fromPost(post) {
  const title = strip(post.title?.rendered);
  const override = POST_THUMB_OVERRIDES.find((o) => title.includes(o.match));
  return {
    key: `wp-${post.id}`,
    date: (post.date || "").slice(0, 10),
    cat: "お知らせ",
    title,
    excerpt: strip(post.excerpt?.rendered).replace(/\s*…\s*$/, ""),
    to: `/news/${post.slug}`,
    thumb:
      post._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
      override?.thumb ||
      null,
  };
}

const byDateDesc = (a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0);

/** プレスリリース（手動）と WordPress の投稿を、新しい順に混ぜて返す。 */
export function useNewsItems() {
  const [items, setItems] = useState(() =>
    [...PRESS_RELEASES, ...FALLBACK_POSTS].sort(byDateDesc),
  );
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    fetchNews({ per_page: 20 })
      .then((posts) => {
        if (!alive) return;
        const wp = posts
          .map(fromPost)
          .filter((p) => !EXCLUDED_POST_TITLES.includes(p.title));
        setItems([...PRESS_RELEASES, ...wp].sort(byDateDesc));
      })
      .catch((err) => console.error("[news] fetch error:", err))
      .finally(() => alive && setLoaded(true));
    return () => {
      alive = false;
    };
  }, []);

  return { items, loaded };
}

export const formatDate = (iso) => (iso || "").replaceAll("-", ".");
